import {
	PaintChipInstructionsListFirstItemText,
	PaintChipInstructionsListFourthItemText,
	PaintChipInstructionsListSecondItemText,
	PaintChipInstructionsListThirdItemText,
	PaintChipInstructionsSubtitleText,
	PaintChipInstructionsTitleText
} from "constants/text";
import {
	PaintChipInstructionsContainer,
	PaintChipInstructionsList,
	PaintChipInstructionsListItem,
	PaintChipInstructionsSubtitle,
	PaintChipInstructionsTextContainer,
	PaintChipInstructionsTitle
} from "./PaintChipInstructions.styles";

const PaintChipInstructions = () => {
	return (
		<PaintChipInstructionsContainer data-testid="paint-chip-instructions">
			<img
				src="/assets/MailingGraphic.svg"
				alt="Paint Chip Instructions"
				width={164}
				height={148}
				data-testid="paint-chip-image"
			/>
			<PaintChipInstructionsTextContainer data-testid="paint-chip-text-container">
				<PaintChipInstructionsTitle data-testid="paint-chip-title">
					{PaintChipInstructionsTitleText}
				</PaintChipInstructionsTitle>
				<div>
					<PaintChipInstructionsSubtitle data-testid="paint-chip-subtitle">
						{PaintChipInstructionsSubtitleText}
					</PaintChipInstructionsSubtitle>
					<PaintChipInstructionsList data-testid="paint-chip-list">
						<PaintChipInstructionsListItem data-testid="paint-chip-list-item-1">
							{PaintChipInstructionsListFirstItemText}
						</PaintChipInstructionsListItem>
						<PaintChipInstructionsListItem data-testid="paint-chip-list-item-2">
							{PaintChipInstructionsListSecondItemText}
						</PaintChipInstructionsListItem>
						<PaintChipInstructionsListItem data-testid="paint-chip-list-item-3">
							{PaintChipInstructionsListThirdItemText}
						</PaintChipInstructionsListItem>
						<PaintChipInstructionsListItem data-testid="paint-chip-list-item-4">
							{PaintChipInstructionsListFourthItemText}
						</PaintChipInstructionsListItem>
					</PaintChipInstructionsList>
				</div>
			</PaintChipInstructionsTextContainer>
		</PaintChipInstructionsContainer>
	);
};

export default PaintChipInstructions;
